import { render, staticRenderFns } from "./DownloadLabelsButton.vue?vue&type=template&id=24d8358d"
import script from "./DownloadLabelsButton.vue?vue&type=script&lang=js"
export * from "./DownloadLabelsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports